import { createFileRoute } from '@tanstack/react-router';
import { InvestmentStrategyPage } from '../pages/investment-strategy-page';

export const Route = createFileRoute('/strategy')({ component: InvestmentStrategyPage });
